import ErrorIcon from 'assets/svg/error/error-sm.svg'
import VoucherIcon from 'assets/svg/profile/voucher.svg'
import Flex from 'common/components/Flex'
import Skeleton from 'common/components/Skeleton'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import { useEffect } from 'react'
import { useStoreActions, useStoreState } from 'stores/hooks'
import styled from 'styled-components'

const MenuLink = styled.a`
  ${theme.typography.rsubtitle}
  display: flex;
  padding: 8px;
  margin: 2px;
  align-items: center;
  color: ${theme.colors.black};
  border-radius: ${theme.radius.base};
  :hover {
    background-color: ${theme.colors.grayLighter};
  }
`

const StyledVoucherIcon = styled(VoucherIcon)`
  margin-right: 12px;
`

const StyledErrorIcon = styled(ErrorIcon)`
  color: ${theme.colors.red};
  margin-right: 4px;
`

const MenuLinkContent = styled(Flex)`
  flex: 1 0 auto;
`

function MenuVoucher(): JSX.Element {
  const {
    data,
    isError,
    isLoading,
    alreadyGetMyVoucher,
  } = useStoreState((state) => state.myVoucher)

  const { getMyVoucher } = useStoreActions(
    (actions) => actions.myVoucher,
  )

  useEffect(() => {
    if (!alreadyGetMyVoucher) getMyVoucher({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <MenuLink
      {...(!isLoading && {
        href: `${WEB_DESKTOP_RALALI_URL}/ralalipoin?tab=my-voucher`,
      })}
    >
      {isLoading && <Skeleton height="19px" />}
      {!isLoading && (
        <>
          <StyledVoucherIcon />
          <MenuLinkContent
            justifyContent="space-between"
            alignItems="center"
          >
            <span>Voucher</span>
            {isError ? (
              <Flex alignItems="center">
                <StyledErrorIcon />
                <Typography
                  type="bsubtitle"
                  color="red"
                  fontSize="11px"
                  fontWeight="normal"
                >
                  Dalam Perbaikan
                </Typography>
              </Flex>
            ) : (
              <Typography type="bsubtitle" color="orange">
                {`${data.length} Voucher`}
              </Typography>
            )}
          </MenuLinkContent>
        </>
      )}
    </MenuLink>
  )
}

export default MenuVoucher
